export default function FeatureGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="section-container">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
            Popular Finds
            <br />
            <span className="font-heading italic font-normal text-primary-600">This Week</span>
          </h2>
          <p className="text-sm text-foreground-500 max-w-sm">
            Trending items handpicked from the Sugargoo spreadsheet, loved by the community
          </p>
        </div>

        {/* Three-column grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {/* First card - larger (Sneakers) */}
          <div className="md:col-span-1 bg-background-100 rounded-2xl overflow-hidden group cursor-pointer">
            <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="block">
              <div className="aspect-[4/5] overflow-hidden bg-primary-50/50">
                <img
                  src="https://readdy.ai/api/search-image?query=Three%20pairs%20of%20trendy%20sneakers%20in%20neutral%20tones%20artistically%20arranged%20on%20cream%20linen%20surface%2C%20warm%20afternoon%20light%20from%20window%2C%20editorial%20flat%20lay%20photography%2C%20minimalist%20composition%20with%20natural%20textures&width=800&height=1000&seq=feat-sneak-v2-2026&orientation=portrait"
                  alt="Best Sneakers on Sugargoo Spreadsheet - trending picks"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block text-xs font-medium bg-primary-100 text-primary-700 px-2.5 py-1 rounded-full mb-3">
                  Sneakers
                </span>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">Best Sneakers on Sugargoo</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">Discover the latest sneaker finds from top sellers with detailed QC photos and reliable purchase links. Updated every week.</p>
                <div className="flex items-center gap-1.5 mt-3 text-primary-600 font-medium text-sm">
                  View Products <i className="ri-arrow-right-up-line"></i>
                </div>
              </div>
            </a>
          </div>

          {/* Second card (Hoodies) */}
          <div className="bg-background-100 rounded-2xl overflow-hidden group cursor-pointer">
            <a href="https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html" target="_blank" rel="noopener nofollow" className="block">
              <div className="aspect-[4/3] overflow-hidden bg-secondary-50/50">
                <img
                  src="https://readdy.ai/api/search-image?query=Cozy%20oversized%20cream%20hoodie%20laid%20flat%20on%20warm%20wooden%20floor%20with%20morning%20sunlight%2C%20soft%20fabric%20folds%20and%20texture%2C%20editorial%20lifestyle%20photography%2C%20warm%20neutral%20aesthetic%2C%20inviting%20atmosphere&width=800&height=600&seq=feat-hoodie-v2-2026&orientation=landscape"
                  alt="Top Hoodies and Sweaters from Sugargoo Spreadsheet"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block text-xs font-medium bg-secondary-100 text-secondary-700 px-2.5 py-1 rounded-full mb-3">
                  Hoodies
                </span>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">Top Hoodies &amp; Sweaters</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">Cozy, stylish hoodies from verified Sugargoo sellers. Fresh finds and community reviews added weekly.</p>
                <div className="flex items-center gap-1.5 mt-3 text-primary-600 font-medium text-sm">
                  View Products <i className="ri-arrow-right-up-line"></i>
                </div>
              </div>
            </a>
          </div>

          {/* Third card (Accessories) */}
          <div className="bg-background-100 rounded-2xl overflow-hidden group cursor-pointer">
            <a href="https://kaspreadsheet.com/category-920-Accessories.html" target="_blank" rel="noopener nofollow" className="block">
              <div className="aspect-[4/3] overflow-hidden bg-accent-50/50">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20arrangement%20of%20minimalist%20watch%20leather%20bracelet%20and%20metal%20ring%20on%20cream%20marble%20surface%2C%20soft%20studio%20lighting%20with%20warm%20reflections%2C%20editorial%20accessory%20flat%20lay%2C%20sophisticated%20neutral%20palette&width=800&height=600&seq=feat-acc-v2-2026&orientation=landscape"
                  alt="Popular Accessories from Sugargoo Spreadsheet"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block text-xs font-medium bg-accent-100 text-accent-700 px-2.5 py-1 rounded-full mb-3">
                  Accessories
                </span>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">Popular Accessories</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">Watches, sunglasses, belts, and more — all verified and linked directly from the spreadsheet for easy shopping.</p>
                <div className="flex items-center gap-1.5 mt-3 text-primary-600 font-medium text-sm">
                  View Products <i className="ri-arrow-right-up-line"></i>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}